"use strict";

(function () {
  var supportChatButtonSelector = '#footerSupportChatButton, #jsOpenSupportChat, #managerSupportChatButton, .js-open-support-chat';
  $(document).on('click', supportChatButtonSelector, function (event) {
    event.preventDefault();
    var widget = document.getElementById('chatWidget');
    if (!widget || typeof widget.openSupportChat !== 'function') {
      return;
    }
    widget.openSupportChat();
  });
})();